// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		if(document.getElementById('home')){
			scrollDownAction(60, 'scroll');
		}

		window.addEventListener('scroll', function(){
			scrollW();
		})

		if(document.querySelector('.menu__images')){
			let itemsMenuNav = document.querySelectorAll('.privary-navigation__item a');
			let imagesNav = document.querySelectorAll('.menu__images img');
			itemsMenuNav.forEach((item)=>{
				let dataNav = item.innerHTML.toLowerCase();
				item.setAttribute('data-nav', dataNav);
				item.addEventListener('mouseenter', (e)=>{
					let data = e.target.dataset.nav;
					imagesNav.forEach((img)=>{
						img.classList.toggle('active', data == img.dataset.nav);
					})
				})

				if(item.classList.contains('active')){
					let dataActive = item.dataset.nav;
					document.querySelector('.menu__images [data-nav="'+ dataActive+'"]').classList.add('active');
				}
			})
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(document.querySelector('.js-open-langs')){
		document.querySelector('.js-open-langs').addEventListener('click', ()=>{
			document.querySelector('.lang .list-langs').classList.toggle('active');
		})
	}

	document.querySelectorAll('.js-open-menu').forEach((button)=>{
		button.addEventListener('click', ()=>{
			document.getElementById('menu').classList.add('show');
		})
	})

	document.querySelector('.js-close-menu').addEventListener('click', ()=>{
		document.getElementById('menu').classList.remove('show');
	})

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	let scrollButtons = document.querySelectorAll('.js-scroll');

	if(scrollButtons.length > 0){
		scrollButtons.forEach((button)=>{
			button.addEventListener('click', (e)=>{
				e.preventDefault();
				let data = button.getAttribute('href').split('#')[1];
				let target = document.getElementById(data);
				let headerHeight = document.querySelector('header').offsetHeight;

				window.scrollTo({
					top: target.offsetTop - headerHeight,
					behavior: 'smooth'
				});
			});
		});
	}

	if(document.querySelector('#email-signup')){
		let buttonForm = document.querySelector('#email-signup .signup-btn');
		let form = document.querySelector('#email-signup .fields-wrap');
		form.insertAdjacentElement("beforeend", buttonForm);
	}

	if(document.querySelector('.timeline')){
		let tabsTimeline = document.querySelectorAll('.timeline__tabs li');
		let lastClick = null;

		tabsTimeline.forEach((tab)=>{
			tab.addEventListener('click', (e)=>{
				let tag = e.target.dataset.year;
				let items = document.querySelectorAll('[data-year]');
				items.forEach((item)=>{
					item.classList.toggle('active',item.dataset.year == tag)
				})
			})
		})

		tabsTimeline[0].click();
	}

	if(document.querySelector('.accordion')){
		document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text)=>{
			text.classList.add('animate-fade', 'top');
		})
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	document.addEventListener('DOMContentLoaded', () => {
		let emailSignUpButtonHeader = document.querySelector('.buttonReplaceBookNow');
		if( emailSignUpButtonHeader ){
			emailSignUpButtonHeader.addEventListener( 'click', (e) => {
				e.preventDefault();
				document.querySelector('footer form#email-signup').scrollIntoView({ 
					behavior: "smooth", 
					block: "center"
				});
			} );
		}
	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 60){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#menu');
    const isMenuVisible = menu && menu.classList.contains('show');
    const elements = document.querySelectorAll('#menu .privary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});

